export default __webpack_public_path__ + "static/media/roboto-v20-latin-italic.a9a7cfe6.eot";